/* The domains parents get their report links on. On these the app shows only the report links
 * and a 404 for everything else (see SprHostApp). Add a domain here when a new SPR domain is set up. */
const SPR_HOSTS = ["spr.dev.codeyoung.com", "spr.codeyoung.com"];

/**
 * True when the app is opened on an SPR domain: one of SPR_HOSTS, or, for local testing only,
 * REACT_APP_SPR_HOST (e.g. "localhost:3000" in your own .env). Any other address → false, and
 * the full Epicenter app renders as before.
 *
 * Read from the browser's address, not from the build, because the same code is deployed to
 * the Epicenter domain and to the SPR domain.
 */
export const isSprHost = () => {
  const host = window.location.host?.toLowerCase();
  const localTestHost = process.env.REACT_APP_SPR_HOST?.trim()?.toLowerCase();
  return SPR_HOSTS?.includes(host) || (!!localTestHost && host === localTestHost);
};